import { Navigate } from "react-router-dom";
import auth from "shared/Auth0";

export default function LogoutPage() {
  auth.logout();

  return <Navigate to="/" />;
}
